import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, IconButton } from "@mui/material";

const RecievedNotifications = () => {

    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    return (
        <>
            <div className="main_title">
                <h1>Recieved Notifications</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    Recieved Notifications
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                        />
                    </div>
                </div>
                <TableContainer className="table_container">
                    <Box className="heading"></Box>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table" className="v3">
                        <TableHead>
                            <TableRow hover>
                                <TableCell>User Name</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Message</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow hover>
                                <TableCell>
                                    <div className="user_block">
                                        <figure>
                                            <img src="/static/images/user_placeholder.png" alt="" />
                                        </figure>
                                        <p>
                                            <b>Emma Smith</b>
                                            <span>emmasmith@gmail.com</span>
                                        </p>
                                    </div>
                                </TableCell>
                                <TableCell>New Notification Recieved</TableCell>
                                <TableCell className="max_c2">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </TableCell>
                                <TableCell>12 Jan 2024</TableCell>
                                <TableCell>
                                    <div className="table_actions v2">
                                        <Box>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </Box>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow hover>
                                <TableCell>
                                    <div className="user_block">
                                        <figure>
                                            <img src="/static/images/user_placeholder.png" alt="" />
                                        </figure>
                                        <p>
                                            <b>Emma Smith</b>
                                            <span>emmasmith@gmail.com</span>
                                        </p>
                                    </div>
                                </TableCell>
                                <TableCell>New Notification Recieved</TableCell>
                                <TableCell className="max_c">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </TableCell>
                                <TableCell>12 Jan 2024</TableCell>
                                <TableCell>
                                    <div className="table_actions v2">
                                        <Box>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </Box>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow hover>
                                <TableCell>
                                    <div className="user_block">
                                        <figure>
                                            <img src="/static/images/user_placeholder.png" alt="" />
                                        </figure>
                                        <p>
                                            <b>Emma Smith</b>
                                            <span>emmasmith@gmail.com</span>
                                        </p>
                                    </div>
                                </TableCell>
                                <TableCell>New Notification Recieved</TableCell>
                                <TableCell className="max_c">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </TableCell>
                                <TableCell>12 Jan 2024</TableCell>
                                <TableCell>
                                    <div className="table_actions v2">
                                        <Box>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </Box>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow hover>
                                <TableCell>
                                    <div className="user_block">
                                        <figure>
                                            <img src="/static/images/user_placeholder.png" alt="" />
                                        </figure>
                                        <p>
                                            <b>Emma Smith</b>
                                            <span>emmasmith@gmail.com</span>
                                        </p>
                                    </div>
                                </TableCell>
                                <TableCell>New Notification Recieved</TableCell>
                                <TableCell className="max_c">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </TableCell>
                                <TableCell>12 Jan 2024</TableCell>
                                <TableCell>
                                    <div className="table_actions v2">
                                        <Box>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </Box>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow hover>
                                <TableCell>
                                    <div className="user_block">
                                        <figure>
                                            <img src="/static/images/user_placeholder.png" alt="" />
                                        </figure>
                                        <p>
                                            <b>Emma Smith</b>
                                            <span>emmasmith@gmail.com</span>
                                        </p>
                                    </div>
                                </TableCell>
                                <TableCell>New Notification Recieved</TableCell>
                                <TableCell className="max_c">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </TableCell>
                                <TableCell>12 Jan 2024</TableCell>
                                <TableCell>
                                    <div className="table_actions v2">
                                        <Box>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </Box>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default RecievedNotifications;
